/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc
 */
import * as References from './MarketplaceInstallsRpc-app';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallCount
 */
export const GET_INSTALL_COUNT_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallCount';
export const GET_INSTALL_COUNT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTALL_COUNT_QUERY_FIELD_NAME,
  args: ['listingId', 'slug'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getInstallCountRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallCountBatch
 */
export const GET_INSTALL_COUNT_BATCH_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallCountBatch';
export const GET_INSTALL_COUNT_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTALL_COUNT_BATCH_QUERY_FIELD_NAME,
  args: ['listingIds', 'slugs'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getInstallCountBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#sendInstallIntent
 */
export const SEND_INSTALL_INTENT_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_sendInstallIntent';
export const SEND_INSTALL_INTENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEND_INSTALL_INTENT_QUERY_FIELD_NAME,
  args: ['slug'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.sendInstallIntentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallCompatibility
 */
export const GET_INSTALL_COMPATIBILITY_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallCompatibility';
export const GET_INSTALL_COMPATIBILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTALL_COMPATIBILITY_QUERY_FIELD_NAME,
  args: ['listingId', 'published', 'listingLanguage'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getInstallCompatibilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallability
 */
export const GET_INSTALLABILITY_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallability';
export const GET_INSTALLABILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTALLABILITY_QUERY_FIELD_NAME,
  args: ['listingId', 'published', 'listingLanguage'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getInstallabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getOAuthUrl
 */
export const GET_OAUTH_URL_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getOAuthUrl';
export const GET_OAUTH_URL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OAUTH_URL_QUERY_FIELD_NAME,
  args: ['listingId', 'published'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getOAuthUrlRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getInstallExemptionStatus
 */
export const GET_INSTALL_EXEMPTION_STATUS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getInstallExemptionStatus';
export const GET_INSTALL_EXEMPTION_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTALL_EXEMPTION_STATUS_QUERY_FIELD_NAME,
  args: ['productId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getInstallExemptionStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#getRequiredScopeGroups
 */
export const GET_REQUIRED_SCOPE_GROUPS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_getRequiredScopeGroups';
export const GET_REQUIRED_SCOPE_GROUPS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_REQUIRED_SCOPE_GROUPS_QUERY_FIELD_NAME,
  args: ['appId', 'listingId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getRequiredScopeGroupsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc#checkRequiredScopeGroupsInSync
 */
export const CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsRpc_checkRequiredScopeGroupsInSync';
export const CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY_FIELD_NAME,
  args: ['listingVersionId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.checkRequiredScopeGroupsInSyncRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});